export default class Campaign {
    search;

    constructor() {
        this.search = document.getElementsByClassName('campaign__filter--input');
        this.searchIcon = document.querySelector('.campaign__filter--seach > .campaign__filter--search-icon');
        this.headerAddToCart();
        this.setAllP2PCampaignsUrl()
    }

    init() {
        this.searchInput();
        this.searchIconSumbit();
    }

    searchInput(){
        Array.from(this.search).forEach((el, index) => {
            el.onkeypress = function (e) {
                if (!e) e = window.event;
                var keyCode = e.keyCode || e.which;
                if (keyCode == '13') {
                    window.location.search = '?search=' + el.value;
                    return false;
                }
            }
        })
    }

    searchIconSumbit(){
        if(!this.searchIcon){
            return;
        }
        this.searchIcon.addEventListener('click', (e) => {
            let searchInputContainer = this.searchIcon.closest('.campaign__filter--seach')
            if(searchInputContainer){
                let searchInput = searchInputContainer.querySelector('input');
                if(searchInput){
                    let searchInputValue = searchInput.value;
                    if(searchInputValue === ''){
                        return;
                    }
                    window.location.search = '?search=' + searchInputValue;
                    return false;
                }
            }
        });
    }

    headerAddToCart() {
        document.addEventListener('click', event => {
            if (event.target.closest('.header-add-campaign-to-cart')) {
                document.querySelector('form.add_campaign_to_cart .levcharity_button').click();
            }
        })
    }

    setAllP2PCampaignsUrl(){
        const allP2PsA = document.querySelector('.product-type-p2p-campaign .link_to_all_p2ps')
        if(!allP2PsA) return

        allP2PsA.href += 'my-mitzvah-all-campaigns'
    }
}



